const TOP_BORDER_FOR_CARD = -40;
const BOTTOM_BORDER_FOR_CARD = window.innerHeight - 136;
const LEFT_BORDER_FOR_CARD = 0;
const RIGHT_BORDER_FOR_CARD = window.innerWidth - 632;

export { TOP_BORDER_FOR_CARD, BOTTOM_BORDER_FOR_CARD, LEFT_BORDER_FOR_CARD, RIGHT_BORDER_FOR_CARD };
